import nombres from "./nombresPantalla.json";

const rutaManuales = {
  "/perfil": { archivo: "Perfil.js", modulo: null },
  "": { archivo: "Home.js", modulo: null },
  "/usuarios": { archivo: "Usuarios.js", modulo: "GestionUsuarios" },
  "/centro-costos": { archivo: "CentroCostos.js", modulo: "GestionUsuarios" },
  "/usuarios-con-firma": { archivo: "UsuariosConFirma.js", modulo: "GestionUsuarios" },
  "/grupos": { archivo: "GruposEditor.js", modulo: "GestionUsuarios" },
  "/grupos-masivos": { archivo: "GruposMasivos.js", modulo: "GestionUsuarios" },
  "/asignacion-cecos-masivo": { archivo: "CecosMasivos.js", modulo: "GestionUsuarios" },
  "/umasivos": { archivo: "UsuariosMasivos.js", modulo: "GestionUsuarios" },
  "/changepass": { archivo: "ChangePass.js", modulo: "GestionUsuarios" },
  "/lista-negra": { archivo: "ListaNegra.js", modulo: "GestionUsuarios" },
  "/aprobaciones": { archivo: "AprobacionesNiveles.js", modulo: "GestionPermisosRoles" },
  "/permisos-roles": { archivo: "PermisosRoles.js", modulo: "GestionPermisosRoles" },
  "/permisos-por-rol": { archivo: "PermisosPorRol.js", modulo: "GestionPermisosRoles" },
  "/historial-cambios": { archivo: "HistorialCambios.js", modulo: "GestionUsuarios" },
  "/permisos-roles/usuarios-con-roles": { archivo: "UsuariosConRoles.js", modulo: "GestionPermisosRoles" },
  "/formularios": { archivo: "Formularios.js", modulo: null },
  "/comunicados": { archivo: "Comunicados.js", modulo: null },
  "/documentos": { archivo: "Documentos.js", modulo: "GestionDocumental" },
  "/documentos/descargar-documentos": { archivo: "DescargarDocumentosGestion.js", modulo: "GestionDocumental" },
  "/documentos/contratos": { archivo: "GeneradorContratos.js", modulo: "GestionDocumental" },
  "/documentos/contratos-plantillas": { archivo: "ContratosPlantillas.js", modulo: "GestionDocumental" },
  "/reglamentos": { archivo: "Reglamentos.js", modulo: "GestionDocumental" },
  "/masivos": { archivo: "Masivos.js", modulo: "GestionDocumental" },
  "/eliminar-masivo": { archivo: "MasivosEliminar.js", modulo: "GestionDocumental" },
  "/renombrar": { archivo: "RenombrarBoletas.js", modulo: "GestionDocumental" },
  "/cmasivos": { archivo: "CorreoMasivo.js", modulo: "GestionDocumental" },
  "/documentos/gdocumentos": { archivo: "GDocumentos.js", modulo: null },
  "/gfirmas": { archivo: "GFirmas.js", modulo: null },
  "/plantillas": { archivo: "Plantillas.js", modulo: null },
  "/dplantillas": { archivo: "Dplantillas.js", modulo: null },
  "/firma": { archivo: null },  // Firma sin mapeo
  "/signDetector": { archivo: "PDFSignatureDetector.js", modulo: "GestionDocumental" },
  "/onboarding": { archivo: "Onboarding.js", modulo: "GestionOnboarding" },
  "/ConfiguracionDocumentos": { archivo: "ConfiguracionDocumentos.js", modulo: "GestionOnboarding" },
  "/onboarding/editor-cabecera": { archivo: "EditorCabeceraSGI.js", modulo: "GestionOnboarding" },
  "/ListaDocumentosDetalle": { archivo: "ListaDocumentosDetalle.js", modulo: "GestionOnboarding" },
  "/ListaMaestra": { archivo: "ListaMaestra.js", modulo: "GestionOnboarding" },
  "/SeguimientoOnboarding": { archivo: "SeguimientoOnboarding.js", modulo: "GestionOnboarding" },
  "/onboarding/descargar-documentos": { archivo: "DescargarDocumentos.js", modulo: "GestionOnboarding" },
  "/dj": { archivo: "DeclaracionJurada.js", modulo: "GestionOnboarding" },
  "/solicitud": { archivo: "Solicitud.js", modulo: "GestionOnboarding" },
  "/onboarding/gestion-medica": { archivo: "GestionMedica.js", modulo: "GestionOnboarding" },
  "/onboarding/enviar-examen-medico": { archivo: "EnviarExamenMedico.js", modulo: "GestionOnboarding" },
  "/onboarding/ficha-personal": { archivo: "FichaPersonal.js", modulo: "GestionOnboarding" },
  "/CurriculumUpload": { archivo: "CurriculumUploadScreen.js", modulo: null },
  "/vacantes": { archivo: "VacantesListScreen.js", modulo: null },
  "/vacantes/crear": { archivo: "VacanteFormScreen.js", modulo: null },
  "/vacantes/:id": { archivo: "VacanteFormScreen.js", modulo: null },
  "/catalogos": { archivo: "CatalogosLayout.js", modulo: null },
  "areas": { archivo: "AreasScreen.js", modulo: null },
  "habilidades": { archivo: "HabilidadesScreen.js", modulo: null },
  "profesiones": { archivo: "ProfesionesScreen.js", modulo: null },
  "perfiles": { archivo: "PerfilesScreen.js", modulo: null },
  "/coordenadas": { archivo: "AsistenciaCoordenadas.js", modulo: "GestionAsistencias" },
  "/reportes-asistencia": { archivo: "ReportesAA.js", modulo: "GestionAsistencias" },
  "/asistencia/aprobaciones": { archivo: "AprobacionesAsistencia.js", modulo: "GestionAsistencias" },
  "/config-asistencia": { archivo: "ConfiguracionAsistencia.js", modulo: "GestionAsistencias" },
  "/asistencia/telegram": { archivo: "TelegramAsistencia.js", modulo: "GestionAsistencias" },
  "/regul-marcacion": { archivo: "RegularizarMarcacion.js", modulo: "GestionAsistencias" },
  "/AsistenciaPDF": { archivo: "ReporteAsistenciaPDF.js", modulo: "GestionAsistencias" },
  "/importar-marcacion": { archivo: "ImportarMarcacion.js", modulo: "GestionAsistencias" },
  "/reporte-ingresos": { archivo: "ReporteIngresos.js", modulo: "GestionAsistencias" },
  "/gestion-transporte": { archivo: "GestionTransporte.js", modulo: "GestionAsistencias" },
  "/reporte-trazabilidad": { archivo: "ReporteTrazabilidad.js", modulo: "GestionAsistencias" },
  "/rol-turnos": { archivo: "RolTurnos.js", modulo: "GestionAsistencias" },
  "/eventos": { archivo: "EventosAsistencia.js", modulo: "GestionAsistencias" },
  "/activos/entrega": { archivo: "EntregaActivosList.js", modulo: null },
  "/activos/entrega/:id": { archivo: "EntregaActivos.js", modulo: null },
  "/catalogo_epps": { archivo: "CatalogoEPPs.js", modulo: null },
  "/catalogo_equipos": { archivo: "CatalogoEquipos.js", modulo: null },
  "/catalogo_herramientas": { archivo: "CatalogoHerramientas.js", modulo: null },
  "/estadistica_epps": { archivo: "EstadisticaEPP.js", modulo: null },
  "/prestamos_activos": { archivo: "GestionPrestamos.js", modulo: null },
  "/ausencias/dashboard": { archivo: "DashboardAusencias.js", modulo: "GestionAusencias" },
  "/ausencias/alertas": { archivo: "AlertasVacaciones.js", modulo: "GestionAusencias" },
  "/ausencias/impacto-financiero": { archivo: "ImpactoFinanciero.js", modulo: "GestionAusencias" },
  "/ausencias/incremento-automatico": { archivo: "IncrementoVacaciones.js", modulo: "GestionAusencias" },
  "/ausencias/vacaciones-masivas": { archivo: "VacacionesMasivas.js", modulo: "GestionAusencias" },
  "/ausencias/vacaciones-detalle": { archivo: "VacacionesDetalle.js", modulo: "GestionAusencias" },
  "/ausencias/ausencias-detalle": { archivo: "AusenciasDetalle.js", modulo: "GestionAusencias" },
  "/ausencias/indicadores": { archivo: "IndicadoresAusentismo.js", modulo: "GestionAusencias" },
  "/ausencias/ausentes-mes": { archivo: "TrabajadoresAusentesMes.js", modulo: "GestionAusencias" },
  "/ausencias/admin": { archivo: "AdminAusencias.js", modulo: "GestionAusencias" },
  "/ausencias/calendario": { archivo: "CalendarioAusencias.js", modulo: "GestionAusencias" },
  "/ausencias/solicitud": { archivo: "SolicitudAusencia.js", modulo: "GestionAusencias" },
  "/ausencias/control-papeletas": { archivo: "ControlPapeletas.js", modulo: "GestionAusencias" },
  "/empleados": { archivo: "Empleados.js", modulo: null },
  "/pagos": { archivo: "Pagos.js", modulo: null },
  "/empleados-masivos": { archivo: "EmpleadosMasivos.js", modulo: null },
  "/planillas": { archivo: "Planillas.js", modulo: null },
  "/boletas-pago": { archivo: "BoletaPago.js", modulo: null },
  "/regimen-trabajo": { archivo: "RegimenTrabajo.js", modulo: null },
  "/ocurrencias": { archivo: "VisualizarOcurrencias.js", modulo: null },
  "/feriados": { archivo: "GestionFeriados.js", modulo: null },
  "/ocurrencias/nueva": { archivo: "OcurrenciasMes.js", modulo: null },
  "/planillas/:id/asientos": { archivo: "AsientosContables.js", modulo: null },
  "/proceso-planilla/:id": { archivo: "ProcesoPlanilla.js", modulo: null },
  "/proceso-planilla": { archivo: "ProcesoPlanilla.js", modulo: null },
  "/config-planilla": { archivo: "ConfiguracionPlanilla.js", modulo: null },
  "/config-contable": { archivo: "ConfiguracionContable.js", modulo: null },
  "/gestion-contable": { archivo: "GestionContable.js", modulo: null },
  "/contabilidad/:seccion": { archivo: "GestionContable.js", modulo: null },
  "/gestion-compras": { archivo: "GestionComprasModulo.js", modulo: null },
  "/gestion-compras/:seccion": { archivo: "GestionComprasModulo.js", modulo: null },
  "/gestion-ventas": { archivo: "GestionVentasModulo.js", modulo: null },
  "/gestion-ventas/:seccion": { archivo: "GestionVentasModulo.js", modulo: null },
  "/gestion-tesoreria": { archivo: "GestionTesoreriaModulo.js", modulo: null },
  "/gestion-tesoreria/:seccion": { archivo: "GestionTesoreriaModulo.js", modulo: null },
  "/config-regimen": { archivo: "ConfiguracionRegimen.js", modulo: null },
  "/bonos": { archivo: "BonoForm.js", modulo: null },
  "/adelantos": { archivo: "AdelantoSalario.js", modulo: null },
  "/planillas/:planillaId/exportacion": { archivo: "ExportacionArchivos.js", modulo: null },
  "/planillas/exportacion": { archivo: "ExportacionArchivos.js", modulo: null },
  "/exportacion-txt": { archivo: "ExportacionArchivos.js", modulo: null },
  "/planillas/config-pdt-plame": { archivo: "ConfiguracionPdtPlame.js", modulo: null },
  "/planillas/:planillaId/exportacion/afpnet": { archivo: "ExportacionArchivos.js", modulo: null },
  "/planillas/:planillaId/exportacion/plame": { archivo: "ExportacionArchivos.js", modulo: null },
  "/planillas/:planillaId/exportacion/tregistro": { archivo: "ExportacionArchivos.js", modulo: null },
  "/documentos/procesador": { archivo: "DocumentosEditor.js", modulo: null },
  "/documentos/procesador/hiro": { archivo: null },  // HiroCVProcessor sin mapeo
  "/documentos/procesador/chat-hiro": { archivo: null },  // HiroChat sin mapeo
  "/documentos/procesador/vexa": { archivo: null },  // VexaQuoteProcessor sin mapeo
  "/documentos/procesador/chat-echo": { archivo: null },  // EchoChat sin mapeo
  "/documentos/procesador/chat-axis": { archivo: null },  // AxisChat sin mapeo
  "/documentos/procesador/chat-axio": { archivo: null },  // AxioChat sin mapeo
  "/documentos/procesador/chat-nova": { archivo: null },  // NovaChat sin mapeo
  "/capacitaciones/dashboard": { archivo: "DashboardPage.js", modulo: null },
  "/capacitaciones/administrar": { archivo: "AdministradorCursosPage.js", modulo: null },
  "/capacitaciones/curso/:cursoId": { archivo: "CursosPage.js", modulo: null },
  "/capacitaciones/crear-curso": { archivo: "CrearCursoPage.js", modulo: null },
  "/capacitaciones/editar-curso/:id": { archivo: "EditarCursoPage.js", modulo: null },
  "/capacitaciones/usuarios": { archivo: "UsuariosPage.js", modulo: null },
  "/evaluaciones": { archivo: "DashboardEvaluacionPage.js", modulo: null },
  "/evaluaciones/crear-campana": { archivo: "CrearCampanaPage.js", modulo: null },
  "/evaluaciones/campana/:campanaid": { archivo: "CampanaPage.js", modulo: null },
  "/evaluaciones/editar-campana/:campanaid": { archivo: "EditarCampanaPage.js", modulo: null },
  "/evaluaciones/resultados/:campanaid": { archivo: "ResultadosPage.js", modulo: null },
  "/atencion/mesa-ayuda": { archivo: "GestionMesaAyuda.js", modulo: null },
  "/atencion/reclamaciones": { archivo: "GestionLibroReclamaciones.js", modulo: null },
  "/p/reclamaciones": { archivo: "PublicReclamaciones.js", modulo: null },
  "/company": { archivo: "Company.js", modulo: null },
  "/docs": { archivo: null },  // DocsManager sin mapeo
  "/alertas-vencimientos": { archivo: "AlertasVencimientos.js", modulo: "GestionUsuarios" },
  "/cumpleanos": { archivo: "Cumpleanos.js", modulo: "GestionUsuarios" },
  "*": { archivo: "Home.js", modulo: null },
};

export function obtenerManual(ruta) {
  const entry = rutaManuales[ruta];
  if (!entry || !entry.archivo) return null;
  return {
    modulo: entry.modulo,
    archivo: entry.archivo,
    nombre: nombres[entry.archivo] || entry.archivo.replace(/\.js$/i, ""),
  };
}

export function existeManual(ruta) {
  const entry = rutaManuales[ruta];
  return !!entry && !!entry.archivo;
}

const componentesIndex = (() => {
  const idx = [];
  for (const [ruta, entry] of Object.entries(rutaManuales)) {
    if (!entry || !entry.archivo) continue;
    const archivoSinExt = entry.archivo.replace(/\.(js|jsx)$/i, "");
    const displayName = nombres[entry.archivo] || archivoSinExt;
    idx.push({
      keywords: [displayName.toLowerCase(), archivoSinExt.toLowerCase()],
      ruta,
      archivo: entry.archivo,
      nombre: displayName,
    });
  }
  return idx;
})();

function variants(palabra) {
  const vars = [palabra];
  if (palabra.endsWith("s")) vars.push(palabra.slice(0, -1));
  else vars.push(palabra + "s");
  if (palabra.endsWith("es")) vars.push(palabra.slice(0, -2));
  if (palabra.endsWith("ción")) vars.push(palabra.replace(/ción$/, "ciones"));
  if (palabra.endsWith("ciones")) vars.push(palabra.replace(/ciones$/, "ción"));
  return [...new Set(vars)];
}

export function buscarComponentesEnTexto(texto) {
  if (!texto) return [];
  const t = texto.toLowerCase();
  const vistos = new Set();
  const resultados = [];
  for (const item of componentesIndex) {
    for (const kw of item.keywords) {
      if (kw.length < 2) continue;
      for (const v of variants(kw)) {
        if (v.length < 2) continue;
        const idx = t.lastIndexOf(v);
        if (idx !== -1) {
          if (!vistos.has(item.ruta)) {
            vistos.add(item.ruta);
            resultados.push({ ...item, posicion: idx });
          }
          break;
        }
      }
    }
  }
  resultados.sort((a, b) => b.posicion - a.posicion);
  return resultados.slice(0, 1);
}

export function obtenerRutaPorArchivo(archivo) {
  if (!archivo) return null;
  for (const [ruta, entry] of Object.entries(rutaManuales)) {
    if (entry && entry.archivo === archivo) {
      return {
        ruta,
        archivo: entry.archivo,
        modulo: entry.modulo,
        nombre: nombres[entry.archivo] || archivo.replace(/\.(js|jsx)$/i, ""),
      };
    }
  }
  return null;
}

export default rutaManuales;